import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScriptService {
  private scripts: { [key: string]: { loaded: boolean; src: string } } = {};

  constructor() {}

  loadScript(name: string, src: string): Promise<void> {
    if (this.scripts[name]) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      script.onload = () => {
        this.scripts[name] = { loaded: true, src };
        resolve();
      };
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      document.head.appendChild(script);
    });
  }
}